import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppNavigation } from '../../hooks';
import { Button } from '../ui';
import './Hero.css';

/**
 * Hero section component
 * Main landing section with animated gradient background and CTA buttons
 */
const Hero: React.FC = () => {
	const { t } = useTranslation();
	const { goToFreeEstimate, goToBookNow } = useAppNavigation();

	return (
		<section className="hero">
			{/* Animated Gradient Background - No watermarked images */}
			<div className="hero-bg visible" aria-hidden="true" />
			
			{/* Overlay */}
			<div className="hero-overlay" aria-hidden="true" />

			{/* Fire particles effect */}
			<div className="fire-particles" aria-hidden="true" />

			<div className="hero-content">
				{/* Tagline */}
				<div className="hero-tagline">
					<h2>🔥 {t('hero.tagline', '#1 Rated Hibachi At Home')} 🔥</h2>
				</div>

				{/* Main Title with fire gradient */}
				<h1>
					<span>FAMILY FRIENDS HIBACHI</span>
				</h1>

				{/* Description */}
				<p>
					{t('hero.description', 'Professional chefs bring the sizzle, spectacle, and authentic hibachi experience directly to your backyard. Perfect for birthdays, weddings, corporate events, and any celebration!')}
				</p>

				{/* Service Areas Badge */}
				<div className="service-areas">
					📍 {t('booking.california')} • {t('booking.texas')} • {t('booking.florida')}
				</div>

				{/* CTA Buttons */}
				<div className="hero-buttons">
					<Button 
						variant="primary" 
						size="lg"
						onClick={goToBookNow}
						className="hero-btn"
					>
						🎉 {t('hero.bookNow')}
					</Button>
					<Button 
						variant="secondary" 
						size="lg"
						onClick={goToFreeEstimate}
						className="hero-btn"
					>
						{t('hero.freeEstimate')}
					</Button>
				</div>

				{/* Slogan */}
				<p className="hero-slogan">#MORESAKEMOREHAPPY</p>
			</div>
		</section>
	);
};

export default Hero;
